export default __webpack_public_path__ + "static/media/Facebook-Marketing-Header.7355fafd.png";